<template>
  <div v-show="show">
    <FormKit
      :classes="{ outer: outerClasses }"
      :help="field.instructions"
      :label="field.name"
      :name="name"
      :placeholder="field.placeholder"
      :validation="validation"
      :value="field.defaultValue"
      type="text"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldName, fieldOuterClasses, fieldTextValidationArray, fieldValidationArray, fieldVisible } from '~/assets/formie'

const props = defineProps({
  settings: { type: Object as PropType<Record<string, any>>, required: true },
  parentField: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  field: { type: Object as PropType<Record<string, any>>, required: true },
})

const name = fieldName(props.field, props.parentField)
const outerClasses = fieldOuterClasses(props.settings, props.field)
const show = fieldVisible(props.field)
const validation = [...fieldValidationArray(props.field), ...fieldTextValidationArray(props.field)]
</script>
